import {Action, Selector, State, StateContext} from '@ngxs/store';
import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {tap} from 'rxjs/operators';
import {Auth} from '../actions/auth.actions';
import {LineItemsActions} from '../actions/lineItems.actions';
import {LineItemsService} from '../services/lineItems.service';
import {JobLineItems} from '../models/line.items/jobLineItems.model';
import ClearState = Auth.ClearState;
import UpdateLineItems = LineItemsActions.UpdateLineItems;
import GetLineItems = LineItemsActions.GetLineItems;
import {JobInstruments} from '../models/instrument/jobInstruments.model';
import {InstrumentService} from '../services/instrument.service';
import {Instruments} from '../actions/instruments.actions';
import UpdateJobInstruments = Instruments.UpdateJobInstruments;
import GetJobInstruments = Instruments.GetJobInstruments;

export interface InstrumentStateModel {
  jobInstruments: JobInstruments | null;
}

@State<InstrumentStateModel>({
  name: 'instruments',
  defaults: {
    jobInstruments: null,
  }
})
@Injectable()
export class InstrumentState {
  constructor(private instrumentService: InstrumentService
  ) {
  }

  @Selector()
  static jobInstruments(state: InstrumentStateModel): JobInstruments {
    return state.jobInstruments;
  }

  @Action(UpdateJobInstruments)
  updateJobInstruments(ctx: StateContext<InstrumentStateModel>, action: UpdateJobInstruments): Observable<JobInstruments> {
    return this.instrumentService.updateJobInstruments(action.jobInstruments).pipe(
      tap(jobInstruments => {
        ctx.patchState({
          jobInstruments
        });
      })
    );
  }

  @Action(GetJobInstruments)
  getJobInstruments(ctx: StateContext<InstrumentStateModel>, action: GetJobInstruments): Observable<JobInstruments> {
    if (!action.force) {
      const jobInstruments = ctx.getState().jobInstruments;
      if (jobInstruments !== null && action.id === jobInstruments.id) {
        return of(jobInstruments);
      }
    }
    return this.instrumentService.getJobInstruments(action.id).pipe(
      tap(jobInstruments => {
        ctx.patchState({
          jobInstruments
        });
      })
    );
  }

  @Action(ClearState)
  clearState(ctx: StateContext<InstrumentStateModel>): void {
    ctx.setState({
      jobInstruments: null
    });
  }
}
